import { useEffect, useState } from 'react';
import useControlPanelOptions from 'utils/hooks/meteorology/useControlPanelOptions';
import { SpecialModels, NA_VALUE } from 'helper/personalized';

export default function useBlockOptions() {
  const [model, setModel] = useState('');
  const [runtime, setRuntime] = useState<number>(-1);
  const [member, setMember] = useState('');
  const [rmv, setRmv] = useState(-1);

  const { models, getModelOptions } = useControlPanelOptions('flux');
  const runtimeOptions = getModelOptions(model).runtimes;
  const memberOptions = getModelOptions(model).members;

  const specialModelSelected = Object.values(SpecialModels).includes(model as SpecialModels);
  // Remoção de viés por modelo vem do backend (`permite_rmv` → `rmvAllowed`).
  const rmvLocked = model !== '' && !getModelOptions(model).rmvAllowed;
  const runtimeDisabled = runtimeOptions.length === 0 || specialModelSelected;
  const modelWithoutMember = specialModelSelected && model !== SpecialModels.Climatology;
  const memberDisabled = memberOptions.length === 0 || modelWithoutMember;
  const rmvDisabled = rmvLocked;

  useEffect(() => {
    if (specialModelSelected) {
      setRuntime(NA_VALUE);
      setMember(NA_VALUE.toString());
    }
  }, [specialModelSelected]);

  useEffect(() => {
    setRmv(rmvLocked ? 0 : -1);
  }, [rmvLocked]);

  return {
    model,
    runtime,
    member,
    rmv,
    modelOptions: models,
    runtimeOptions,
    memberOptions,
    setModel,
    setRuntime,
    setMember,
    setRmv,
    runtimeDisabled,
    memberDisabled,
    rmvDisabled,
  };
}
